import React, { useEffect, useContext } from "react";
import styled from "styled-components";
import ActionsContext from "common/ActionsContext";
import help from "help/viewSubscriberAttributes.md";
import FilteringControls from "./FilteringControls";
import Report from "./Report";
import View from "common/View";

const FilterLayout = styled.div`
  .form-line {
    input.form-control {
      z-index: 0 !important;
    }
  }
`;

export const applyParams = (child, params = {}) =>
  React.isValidElement(child) ? React.cloneElement(child, params) : child;

const Subscribers = ({ subnet, returnView, ...params }) => {
  const actions = useContext(ActionsContext);
  useEffect(() => () => actions.clear(), []);
  return (
    <View
      title="Subscriber Attributes"
      mdHelp={help}
      returnView={returnView}
    >
      <FilterLayout className="body flex-panel-column subscriber-quotas panel-group">
        <FilteringControls {...params} subnet={subnet}>
          {(settings) => <Report {...settings} />}
        </FilteringControls>
      </FilterLayout>
    </View>
  );
};

export default Subscribers;
